import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AccountsLoginPage from "./pages/AccountsLoginPage";
import AccountsRegisterPage from "./pages/AccountsRegisterPage";
import AccountsManageUsers from "./pages/AccountsManageUsers";
import InventoryIngredients from "./pages/InventoryIngredients";
import InventoryProducts from "./pages/InventoryProducts";
import InventoryAddItems from "./pages/InventoryAddItems";
import InventoryRemoveItems from "./pages/InventoryRemoveItems";
import InventoryItemLogs from "./pages/InventoryItemLogs";
import InventoryPriceLogs from "./pages/InventoryPriceLogs";
import OrderGenerateReceipt from "./pages/OrderGenerateReceipt";
import OrderHistory from "./pages/OrderHistory"
import ViewOrderReceipt from './pages/ViewOrderReceipt';
import SuppliersAddReceipt from "./pages/SuppliersAddReceipt";
import SuppliersHistory from "./pages/SuppliersHistory";
import ViewSupplierReceipt from './pages/ViewSupplierReceipt';
import AddNewProduct from "./pages/AddNewProduct";
import AddNewIngredient from "./pages/AddNewIngredient"
import Homepage from "./pages/Homepage";
import EditProduct from "./pages/EditProduct";
import EditIngredient from "./pages/EditIngredient";
import AdminSidebar from "./AdminSidebar";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const App = () => {
    return (
        <Router>
            <ToastContainer 
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Routes>
                {/* Login route (no sidebar) */}
                <Route path="/" element={<AccountsLoginPage />} />
                <Route path="/pages/AccountsLoginPage" element={<AccountsLoginPage />} />

                {/* Routes with sidebar */}
                <Route
                    path="/*"
                    element={
                        <div className="app">
                            <AdminSidebar />
                            <div className="content">
                                <Routes>
                                <Route path="/pages/EditIngredient/:id" element={<EditIngredient />} />
                                <Route path="/pages/EditProduct/:id" element={<EditProduct />} />
                                <Route path="/pages/AccountsRegisterPage" element={<AccountsRegisterPage />} />
                                <Route path="/pages/AccountsManageUsers" element={<AccountsManageUsers />} />
                                <Route path="/pages/InventoryIngredients" element={<InventoryIngredients />} />
                                <Route path="/pages/InventoryProducts" element={<InventoryProducts />} />
                                <Route path="/pages/AddNewProduct" element={<AddNewProduct/>} />
                                <Route path="/pages/InventoryAddItems" element={<InventoryAddItems />} />
                                <Route path="/pages/InventoryRemoveItems" element={<InventoryRemoveItems />} />
                                <Route path="/pages/AddNewIngredient" element={<AddNewIngredient/>} />
                                <Route path="/pages/InventoryItemLogs" element={<InventoryItemLogs />} />
                                <Route path="/pages/InventoryPriceLogs" element={<InventoryPriceLogs />} />
                                <Route path="/pages/OrderGenerateReceipt" element={<OrderGenerateReceipt />} />
                                <Route path="/pages/OrderHistory" element={<OrderHistory />} />
                                <Route path="/pages/ViewOrderReceipt/:id" element={<ViewOrderReceipt />} />
                                <Route path="/pages/SuppliersAddReceipt" element={<SuppliersAddReceipt />} />
                                <Route path="/pages/SuppliersHistory" element={<SuppliersHistory />} />
                                <Route path="/pages/ViewSupplierReceipt/:id" element={<ViewSupplierReceipt />} />
                                <Route path="/pages/Homepage" element={<Homepage />} />
                                </Routes>
                            </div>
                        </div>
                    }
                />
            </Routes>
        </Router>
    );
};

export default App;
